// Play money, as every scene that spends any writes it. One rule rather than one per place: a
// student can walk from the bakery to the station in a session, and two of these would read as two
// currencies.
export const euros = (amount) => `€${amount.toFixed(2)}`;

// Renders `text` with its newlines turned into <br/> elements so multi-line
// messages keep their line breaks in the web page (HTML collapses raw "\n"
// into a single space). Returns the string unchanged when it has no newline,
// otherwise an array of string segments interleaved with keyed <br/> nodes.
export function withLineBreaks(text, keyPrefix = 'br') {
  if (typeof text !== 'string' || !text.includes('\n')) {
    return text;
  }
  const segments = text.split('\n');
  const nodes = [];
  segments.forEach((segment, i) => {
    if (i > 0) {
      nodes.push(<br key={`${keyPrefix}-${i}`} />);
    }
    nodes.push(segment);
  });
  return nodes;
}
